
    var riot = require('riot')
    import { Toggle } from './gb-toggle';
riot.tag2('gb-toggle', '<label> <input ref="input" type="checkbox" onclick="{onClick}"> <div><span></span></div> </label>', 'gb-toggle label,[data-is="gb-toggle"] label{ position: relative; display: inline-block; } gb-toggle input,[data-is="gb-toggle"] input{ display: none; } gb-toggle div,[data-is="gb-toggle"] div{ position: absolute; cursor: pointer; top: 0; left: 0; right: 0; bottom: 0; } gb-toggle span,[data-is="gb-toggle"] span{ position: absolute; }', '', function(opts) {
    this._mixin(Toggle);
});

    
  


// WEBPACK FOOTER //
// ./src/tags/toggle/gb-toggle.tag.html